const GENRE_HINTS = [
  ['dancehall', ['dancehall', 'bashment', 'juggling']],
  ['roots reggae', ['roots', 'conscious', 'dub', 'culture']],
  ['lovers rock', ['lovers', 'romantic', 'love']],
  ['reggae', ['reggae', 'riddim', 'jamaica']],
];

const textOf = (track = {}) => [track.title, track.artist, track.genre, track.description]
  .filter(Boolean)
  .join(' ')
  .toLowerCase();

const inferGenre = (track = {}) => {
  if (track.genre) return track.genre;
  const text = textOf(track);
  const match = GENRE_HINTS.find(([, hints]) => hints.some((hint) => text.includes(hint)));
  return match?.[0] || 'reggae';
};

const normalizeNowPlaying = (track = {}, source = 'audio') => ({
  id: String(track.id || track.track_id || track.youtubeId || track.youtube_id || track.externalUrl || track.url || ''),
  title: track.title || track.name || 'Unknown title',
  artist: track.artist || track.dj || track.channel_title || 'Rastyle',
  cover: track.cover || track.thumbnail || track.image || '',
  genre: inferGenre(track),
  mood: track.mood || '',
  year: track.year || null,
  country: track.country || '',
  label: track.label || '',
  language: track.language || '',
  duration: Math.max(0, Number(track.duration) || 0),
  playbackSource: source,
  externalUrl: track.externalUrl || track.url || '',
  isLive: track.type === 'radio',
  isRadio: track.type === 'radio',
  isPodcast: track.type === 'podcast',
  isYouTube: track.type === 'youtube' || source === 'youtube',
});

const buildDiscoveryPrompts = (media = {}) => {
  if (media.isRadio) return [
    { id: 'schedule', title: 'View show schedule', kind: 'radio' },
    { id: 'request', title: 'Request a tune', kind: 'radio' },
    { id: 'discussion', title: 'Join the discussion', kind: 'community' },
  ];

  return [
    { id: 'similar', title: `More ${media.genre || 'reggae'}`, kind: 'recommendation' },
    { id: 'artist', title: `Explore ${media.artist || 'this artist'}`, kind: 'artist' },
    { id: 'mixes', title: 'Related mixtapes', kind: 'mixtape' },
    { id: 'queue', title: 'Add a similar tune next', kind: 'queue' },
  ];
};

export { buildDiscoveryPrompts, inferGenre, normalizeNowPlaying };
